import React, { useState, useEffect, useRef } from 'react';
import { FLSymbolReverse } from '@lifeomic/phc-web-toolkit/src/components/Logos';

const logoHeight = 24;

export function TrimmedLogo(props) {
  const { alt, logoUrl } = props;
  const [loaded, setLoaded] = useState(false);
  const [displayUrl, setDisplayUrl] = useState('');

  useEffect(() => {
    const calculateTrim = image => {
      const canvas = document.createElement('canvas');
      canvas.width = image.width;
      canvas.height = image.height;
      const context = canvas.getContext('2d');
      context.drawImage(image, 0, 0);
      const pixels = context.getImageData(0, 0, image.width, image.height).data;
      // trim vertical whitespace if transparent, white or black
      // We assume the pixel at (0,0) is the color we want to trim
      // First check if it is a color that should be trimmed
      // Each pixel is 4 array elements (r,g,b,alpha)
      if (
        pixels[3] !== 0 || // pixel is transparent
        (pixels[0] === 0 && pixels[1] === 0 && pixels[2] === 0) || // pixel is black
        (pixels[0] === 255 && pixels[1] === 255 && pixels[2] === 255) // pixel is white
      ) {
        // the pixels are arranged in a 1-dimensional array
        // left to right, top to bottom, like reading a page
        // Find the first pixel that does not match pixel 0
        let first = pixels.length - 1;
        for (let i = 0; i < pixels.length; i++) {
          if (pixels[i] !== pixels[i & 3]) {
            first = i;
            break;
          }
        }
        // find the last pixel that does not match pixel 0
        let last = 0;
        for (let i = pixels.length - 1; i >= 0; i--) {
          if (pixels[i] !== pixels[i & 3]) {
            last = i;
            break;
          }
        }
        return [
          // calculate the y coordinates of the pixels
          Math.round(first / (4 * image.width)),
          Math.round(last / (4 * image.width)),
        ];
      } else {
        return [0, image.height];
      }
    };

    const createTrimmedImage = image => {
      const verticalTrim = calculateTrim(image);
      const canvas = document.createElement('canvas');
      // old width
      canvas.width = image.width;
      // new height
      canvas.height = verticalTrim[1] - verticalTrim[0];
      const context = canvas.getContext('2d');
      context.drawImage(
        image,
        // width from 0 to image.width
        0,
        // height from verticalTrim[0] to vericalTrim[1]
        verticalTrim[0],
        image.width,
        verticalTrim[1] - verticalTrim[0],
        0,
        0,
        canvas.width,
        canvas.height,
      );
      return canvas.toDataURL();
    };

    const fallbackToDefaultLogo = () => {
      setLoaded(false);
    };

    const getVanityUrl = url => {
      // add vanity subdomains for cors
      const imageUrl = new URL(url);
      const windowName = window.location.hostname;
      const imageName = imageUrl.hostname;
      imageUrl.searchParams.append('t', new Date().getTime());
      if (windowName.endsWith(imageName)) {
        imageUrl.hostname = windowName;
        return imageUrl.href;
      } else {
        return url;
      }
    };

    if (logoUrl) {
      const url = getVanityUrl(logoUrl);
      const logo = new Image();
      logo.onload = function () {
        try {
          if (logo.width === 200 && logo.height === 200) {
            // image was stored in old way
            setDisplayUrl(createTrimmedImage(logo));
          } else {
            setDisplayUrl(url);
          }
          setLoaded(true);
        } catch (err) {
          fallbackToDefaultLogo();
        }
      };
      logo.onerror = function () {
        fallbackToDefaultLogo();
      };
      logo.src = url;
    } else {
      fallbackToDefaultLogo();
    }
  }, [logoUrl]);

  return loaded && displayUrl ? (
    <img alt={alt} src={displayUrl} height={logoHeight} width={'auto'} />
  ) : (
    <FLSymbolReverse />
  );
}
